import React, { useState } from "react";

const BulkHolidayForm = ({ loading, closeModal, onSubmit, errors = {} }) => {
    const [holidays, setHolidays] = useState([
        { date: "", occasion: "" },
    ]);

    // Handle input change for each holiday row
    const handleChange = (index, e) => {
        const { name, value } = e.target;
      
        setHolidays((prev) =>
          prev.map((holiday, i) => {
            if (i !== index) return holiday;
      
            let updatedValue = value;
      
            if (name === "occasion") {
              const allowedPattern = /^[A-Za-z. ]*$/;
              if (!allowedPattern.test(value)) {
                return holiday; // Skip update if invalid characters
              }
            }
      
            return {
              ...holiday,
              [name]: updatedValue,
            };
          })
        );
    };
      
      
    // Add a new empty holiday row
    const addRow = () => {
        setHolidays([...holidays, { day: "", date: "", occasion: "" }]);
    };

    // Remove a holiday row
    const removeRow = (index) => {
        if (holidays.length > 1) {
            setHolidays(holidays.filter((_, i) => i !== index));
        }
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();


        // const allowedDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        // for (let i = 0; i < holidays.length; i++) {
        //     const day = holidays[i].day;
        //     if (!allowedDays.includes(day)) {
        //     alert(`${i + 1}st Holiday : Please enter a valid day (Monday to Saturday).`);
        //     return;
        //     }
        // }

        onSubmit(holidays);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            {holidays.map((holiday, index) => (
                <div key={index} className="border dark:border-gray-700 p-4 rounded-md">

                        {/* Day Field */}
                        {/* <div>
                            <label className="block text-sm font-medium dark:text-white text-gray-700">
                                Day <span className="text-red-500 ml-1">*</span>
                            </label>
                            <input
                                type="text"
                                name="day"
                                value={holiday.day}
                                onChange={(e) => handleChange(index, e)}
                                className="mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2"
                                required
                            />
                        </div> */}

                        {/* Date Field */}
                        <div>
                            <label className="block text-sm font-medium dark:text-white text-gray-700">
                                Date <span className="text-red-500 ml-1">*</span>
                            </label>
                            <input
                                type="date"
                                name="date"
                                value={holiday.date}
                                onChange={(e) => handleChange(index, e)}
                                className="mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2"
                                required
                            />
                        </div>

                        {/* Occasion Field */}
                        <div>
                            <label className="block text-sm font-medium dark:text-white text-gray-700">
                                Occasion <span className="text-red-500 ml-1">*</span>
                            </label>
                            <input
                                type="text"
                                name="occasion"
                                value={holiday.occasion}
                                onChange={(e) => handleChange(index, e)}
                                className="mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2"
                                required
                                maxLength={25}
                            />
                            <small>
                                <p className="text-sm text-gray-500 mt-1">
                                    {holiday.occasion.length}/25 characters
                                </p>
                            </small>
                        </div>

                    {/* Remove Button */}
                    {holidays.length > 1 && (
                        <button
                            type="button"
                            onClick={() => removeRow(index)}
                            className="mt-2 text-red-600 hover:text-red-800"
                        >
                            Remove
                        </button>
                    )}
                </div>
            ))}

            {/* Add New Row Button */}
            <button
                type="button"
                onClick={addRow}
                className="px-4 py-2 text-green-700 rounded-md"
            >
                + Add More Holidays
            </button>

            {/* Form Actions */}
            <div className="flex justify-between items-center mt-4">
                <button
                    type="button"
                    onClick={closeModal}
                    className="px-4 py-2 dark:bg-gray-900 dark:text-white bg-gray-500 text-white rounded-md hover:bg-gray-600"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                    Add
                </button>
            </div>
        </form>
    );
};

export default BulkHolidayForm;
